import styled from 'styled-components';
import { rem } from 'approot/shared/style';
import { Heading20, PStyled } from 'approot/shared/styles/typography.style';
import { spacing40 } from 'approot/shared/styles/spacing.style';

export const DownloadingModalBouncerStyled = styled.div`
  margin: ${rem(spacing40)} 0 0;
`;

export const DownloadingModalHeaderStyled = styled(Heading20).attrs({
  as: 'h3',
  textAlignCenter: true,
})``;

export const DownloadingModalTextStyled = styled(PStyled).attrs({
  textAlignCenter: true,
})``;

export const DownloadingModalContainerStyled = styled.div`
  padding: ${rem(spacing40)};
`;
